import {SubmissionFilterDto, SubmissionStateType} from "../../client/submission/SubmissionApiClient";
import {useEffect, useRef} from "react";
import {Grid} from "@mui/material";
import {useTranslation} from "react-i18next";
import {SubmissionTranslKey} from "../submission/SubmissionTranslKey";
import {UserDto} from "../../client/user/User";
import {SearchPanelState, useSubmissionSearch} from "../submission/useSubmissionSearch";
import SubmissionsToAuthorizeGrid from "./SubmissionsToAuthorizeGrid";
import {DEFAULT_PAGING_AND_SORTING_SUBMISSION_FILTER} from "../submission/search/SubmissionSearchPanel";

export interface SubmissionsToAuthorizeSearchPanelProps {
    user: UserDto;
    reloadDashboard: () => void;
}

export default function SubmissionsToAuthorizePanel(props: Readonly<SubmissionsToAuthorizeSearchPanelProps>) {
    const {user, reloadDashboard} = props;

    const {t} = useTranslation();
    const isInitialized = useRef(false);

    const notAuthorizedDefaultFilter: SubmissionFilterDto = {
        submissionStateTypeCodes: [
            SubmissionStateType.WAITING_FOR_AUTHORIZATION,
            SubmissionStateType.AUTHORIZATION_INITIALIZATION_FAILED,
            SubmissionStateType.AUTHORIZATION_IN_PROGRESS,
            SubmissionStateType.NOT_AUTHORIZED
        ],
        submittedAtFrom: buildSubmittedAtFrom(14),
        submittedById: user.id,
        ...DEFAULT_PAGING_AND_SORTING_SUBMISSION_FILTER,
    };

    function buildSubmittedAtFrom(daysAgo: number): Date {
        const date = new Date();
        date.setDate(date.getDate() - daysAgo);
        date.setHours(0, 0, 0, 0);
        return date;
    }

    const {
        submissionSearchPanelState,
        submissionFilter,
        submissionResults,
        displayedSubmissionsCount,
        fetchSubmissions,
        reloadDefaultSubmissionGrid,
        hasAnySubmissions,
    } = useSubmissionSearch(notAuthorizedDefaultFilter);

    useEffect(() => {
        if (!isInitialized.current) {
            isInitialized.current = true;
            reloadDefaultSubmissionGrid();
        }
    }, [reloadDefaultSubmissionGrid]);

    return (
        <>
            {hasAnySubmissions() && (
                <>
                    <h4>{t(SubmissionTranslKey.SUBMISSIONS_TO_AUTHORIZE)}</h4>
                    <Grid container spacing={2} sx={{ marginTop: 2 }}>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={12}>
                                    {submissionSearchPanelState !== SearchPanelState.INITIALIZED && (
                                        <SubmissionsToAuthorizeGrid
                                            rowsData={submissionResults.items}
                                            totalCount={displayedSubmissionsCount}
                                            nextPageToken={submissionResults.nextPageToken}
                                            submissionFilter={submissionFilter}
                                            fetchSubmissions={fetchSubmissions}
                                            reloadSubmissions={reloadDashboard}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </>
            )}
        </>
    );
}
